module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/airbnb-08f1563c5b22eb10cb06c0b47c2bca68.png";